import { useNavigate } from "react-router-dom";
import { UserType } from "../enums/UserType";

const useErrorPage = () => {
    const navigate = useNavigate();

    const toErrorPage = (error: any, userType?: UserType) => {
        if(error.response.status === 401) {
            if(userType === UserType.Recruiter) {
                localStorage.removeItem("recruiter");
                localStorage.removeItem("token");                        
                navigate('/recruiter/account/login');
            }
            else {
                localStorage.removeItem("candidate");
                localStorage.removeItem("savedJobIds");
                localStorage.removeItem("token");
                localStorage.removeItem("verificationShown");
                navigate('/candidates/login');
            }
        }
        else {
            navigate('/error/errorindex', { state: { error: error.message }});
        }
    }
    
    return [toErrorPage];
};

export default useErrorPage;